import { useTranslation } from "react-i18next";
import { BannerSectionWrapper } from "./styles";
import { GoInfo } from "react-icons/go";
import { useRecoilValue } from "recoil";
import { userDetailsStore } from "@store/userDetail";
import { useGetActivePlan, useGetCheckOutRenewal } from "@services";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUserDetail } from "../../../../src/services/home/getUserDetail/index";

export default function BannerSection() {
  const navigate = useNavigate();
  const userDetailsValue = useRecoilValue(userDetailsStore);
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { data } = useGetUserDetail();
  const popUpMessage = data?.result?.popUpMessage;
  const bannerBackgroundColor = popUpMessage?.backgroundColor;
  const titlebannerAr = popUpMessage?.contentAr?.title;
  const titlebannerEn = popUpMessage?.contentEn?.title;
  const subTitlebannerAr = popUpMessage?.contentAr?.subTitle;
  const subTitlebannerEn = popUpMessage?.contentEn?.subTitle;
  const bannerTitleColor = popUpMessage?.titleColor;
  const bannerSubTitleColor = popUpMessage?.subTitleColor;

  const { data: dataActivePlan } = useGetActivePlan(
    {
      lang: language,
    },
    { enabled: language !== undefined }
  );
  const { data: checkOutRenewalData, refetch: refetchCheckOutRenewal } =
    useGetCheckOutRenewal(
      { paymentType: "1" },
      {
        enabled: false,
      }
    );

  useEffect(() => {
    if (checkOutRenewalData?.result?.checkout_url) {
      window.open(checkOutRenewalData?.result?.checkout_url, "_self");
    }
  }, [checkOutRenewalData]);

  return (
    <BannerSectionWrapper
      titleColor={bannerTitleColor}
      subTitleColor={bannerSubTitleColor}
      backGroundColor={bannerBackgroundColor}
    >
      <div>
        <span className="textInfo">
          <span className="title">
            ️
            {`${language === "ar" ? "⌛️" + titlebannerAr : "⌛️" + titlebannerEn}`}
          </span>
          <span className="description">
            {`${language === "ar" ? subTitlebannerAr : subTitlebannerEn}`}
          </span>
        </span>
      </div>
      <div className="containerActions">
        <div className="buttonPay" onClick={() => navigate("/choose-plan")}>
          {t("MANAGE_PLAN.PAY_NOW")}
        </div>
      </div>
    </BannerSectionWrapper>
  );
}
